// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  background-color: var(--wylie-purple);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  position: sticky;
  top: 0;
  z-index: 500;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.nav-logo-img {
  height: 40px;
  width: auto;
  filter: brightness(0) invert(1) brightness(0.88);
}

.nav-logo-text {
  font-size: 2.5rem;
  font-weight: 700;
  color: #e0e0e0;
  margin: 0;
  line-height: 1;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 10px;
  margin: 0;
  padding: 0;
}

.nav-menu li {
  cursor: pointer;
  color: #e0e0e0;
  font-weight: 500;
  transition: color 0.3s;
  padding: 8px 16px;
}

.nav-menu li:hover {
  color: var(--wylie-pink);
}

.feedback-button {
  transition: all 0.3s;
}

.feedback-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-menu li.nav-user {
  color: var(--wylie-pink);
  font-weight: 600;
  cursor: default;
  display: flex;
  align-items: center;
}

.nav-menu li.nav-user:hover {
  color: var(--wylie-pink);
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".navigation {\n  background-color: var(--wylie-purple);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n  position: sticky;\n  top: 0;\n  z-index: 500;\n}\n\n.nav-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 60px;\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.nav-logo-img {\n  height: 40px;\n  width: auto;\n  filter: brightness(0) invert(1) brightness(0.88);\n}\n\n.nav-logo-text {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #e0e0e0;\n  margin: 0;\n  line-height: 1;\n}\n\n.nav-menu {\n  display: flex;\n  list-style: none;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-menu li {\n  cursor: pointer;\n  color: #e0e0e0;\n  font-weight: 500;\n  transition: color 0.3s;\n  padding: 8px 16px;\n}\n\n.nav-menu li:hover {\n  color: var(--wylie-pink);\n}\n\n.feedback-button {\n  transition: all 0.3s;\n}\n\n.feedback-button:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.nav-menu li.nav-user {\n  color: var(--wylie-pink);\n  font-weight: 600;\n  cursor: default;\n  display: flex;\n  align-items: center;\n}\n\n.nav-menu li.nav-user:hover {\n  color: var(--wylie-pink);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
